import React, { Component } from 'react';
import './PvSoundMeter.css';
import SoundMeter from './SoundMeter';
import ProgressBar from 'react-bootstrap/ProgressBar';
import MicIconBase from "./MicIconBase";

class PvSoundMeter extends Component {
    constructor(props) {
        super(props);
        // Nie wywołuj tutaj this.setState()!
        this.state = { volume: 0 };
        this.initSoundMeterIsDone = false;
    }

    initSoundMeter = () => {
        // console.log('Requesting local stream');

        try {
            window.AudioContext = window.AudioContext || window.webkitAudioContext;
            window.audioContext = new AudioContext();
        } catch (e) {
            alert('Web Audio API not supported.');
        }

        const soundMeter = new SoundMeter(window.audioContext);
        soundMeter.connectToSource(this.props.stream, function (e) {
            if (e) {
                alert(e);
                return;
            }

        });
        var intervalId = setInterval(() => { this.setState({ volume: soundMeter.instant.toFixed(2) }) }, 100);
        this.setState({ intervalId: intervalId });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.stream !== this.props.stream && !this.initSoundMeterIsDone) {
            this.initSoundMeter();
            // console.log(this.props.stream);
            // console.log(this.props.stream instanceof MediaStream);
            this.initSoundMeterIsDone = true;
        }
    }

    componentDidMount() {
        if (this.props.stream instanceof MediaStream && !this.initSoundMeterIsDone) {
            this.initSoundMeter();
            // console.log(this.props.stream);
            // console.log(this.props.stream instanceof MediaStream);
            this.initSoundMeterIsDone = true;
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    render() {
        return (
            <div className="PvSoundMeterWrapper">
                <div className="PvSoundMeter">
                    <ProgressBar className="PvSoundMeterProgressBar" min="0" max="0.15" now={this.state.volume} />
                    <MicIconBase />
                </div>
            </div>

        );
    }
}


export default PvSoundMeter;